import Cookies from "js-cookie";

const baseUrl = process.env.REACT_APP_API + "/api";

export const CATEGORY_URL = baseUrl + "/categories";
export const CHECKLIST_EXECUTION_URL = baseUrl + "/checklist-executions";
export const CHECKLIST_BUILDER_URL = baseUrl + "/checklist-builder";
